import {Component, EventEmitter, Input, Output} from '@angular/core';
import {SimpleUser} from "../../services/user.service";
import {FadeInOut} from "../../animations";
import {GroupmateSummary} from "../../services/group.service";
import { TimeagoModule } from 'ngx-timeago';
import { AvatarComponent } from '../avatar/avatar.component';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-user-summary',
    templateUrl: './user-summary.component.html',
    styleUrls: ['./user-summary.component.scss'],
    animations: [FadeInOut(true)],
    standalone: true,
    imports: [NgIf, AvatarComponent, TimeagoModule]
})
export class UserSummaryComponent {

  @Input()
  user?: SimpleUser ;

  @Input()
  groupmateSummary?: GroupmateSummary ;

  @Output()
  tagClicked: EventEmitter<string> = new EventEmitter<string>();

  hovered:boolean = false ;

  handleTagClicked(tag: string) {
    this.tagClicked.emit(tag);
  }
}
